(function () {
  function initRotator(rotator) {
    if (!rotator || rotator.dataset.mbAnnouncementReady === 'true') return;

    const slides = Array.from(rotator.querySelectorAll('[data-mb-announcement-slide]'));
    if (slides.length < 2) return;

    rotator.dataset.mbAnnouncementReady = 'true';

    const viewport = rotator.querySelector('.mb-announcement-bar__viewport');
    const shouldAutoplay = rotator.dataset.mbAutoplay === 'true';
    const speed = Math.max(parseInt(rotator.dataset.mbSpeed, 10) || 5000, 2000);
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
    let hasAnimated = false;
    let timer = null;

    function showSlide(nextIndex) {
      const previousIndex = activeIndex;
      const normalizedIndex = (nextIndex + slides.length) % slides.length;
      if (normalizedIndex === activeIndex && hasAnimated) return;
      activeIndex = normalizedIndex;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        const isLeaving = hasAnimated && index === previousIndex && previousIndex !== activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.classList.toggle('is-entering', hasAnimated && isActive);
        slide.classList.toggle('is-leaving', isLeaving);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.setAttribute('tabindex', isActive ? '-1' : '-1');
        slide.querySelectorAll('a, button').forEach((element) => {
          if (isActive) {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      });

      if (hasAnimated) {
        window.setTimeout(() => {
          slides.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
        }, 280);
      }

      if (viewport) {
        viewport.setAttribute('aria-live', shouldAutoplay ? 'off' : 'polite');
      }

      hasAnimated = true;
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (!shouldAutoplay || timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), speed);
    }

    rotator.addEventListener('mouseenter', stop);
    rotator.addEventListener('mouseleave', start);
    rotator.addEventListener('focusin', stop);
    rotator.addEventListener('focusout', start);

    showSlide(activeIndex);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-mb-announcement-rotator]').forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
